class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    const activeMediaId = this.openedBy.getAttribute('data-media-id');

    this.querySelector(
      `[data-media-id="${activeMediaId}"]`,
    ).parentElement.scrollIntoView();
  }
}

customElements.define('product-modal', ProductModal);
